import React, { useState, useEffect } from "react";
import { Col } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/Admin.css';

export const VendorSetIDDropdown = (props) => {
	const [isLoading, setIsLoading] = useState(true);
	const [vendorSetIDList, setVendorSetIDList] = useState([]);
	const [selectedVendorSetID, setSelectedVendorSetID] = useState(props.currentAudience);
	const [showGlobalOption] = useState(props.showGlobalOption);
	const [showAdminOption] = useState(props.showAdminOption);

	useEffect(() => {
		var showGlobalOpt = (typeof showGlobalOption === 'undefined') ? true : showGlobalOption;
		var showAdminOpt = (typeof showAdminOption === 'undefined') ? false : showAdminOption;
		const fetchVendorSetIDList = async () => {
			ServiceCalls.getVendorSetIDList(showGlobalOpt, showAdminOpt)
				.then(function (data) {
					if (data) {
						setVendorSetIDList(data);
					}
				})
				.catch((error) => {
					console.error("Error occurred while fetching vendor set Id:", error);
				})
				.finally(() => {
					setIsLoading(false);
					//Check if default value is passed in
					if (selectedVendorSetID) {
						setSelectedVendorSetID(selectedVendorSetID);
					}
					props.onListLoaded(true);
				}
				);
		}

		if (vendorSetIDList.length === 0) {
			//props.onListLoaded(false);
			console.log("Fetching Vendor Set ID LIST");
			fetchVendorSetIDList();
		}

	}, [vendorSetIDList]);

	useEffect(() => {
		setSelectedVendorSetID(props.currentAudience);
	}, [props.currentAudience]);

	const selectSetId = (val) => {
		setSelectedVendorSetID(val);
		props.onChange(val);
	}

	var showLabel = (typeof props.showLabel ==='undefined') ? "Supplier Set ID" : props.showLabel;
	return (
		isLoading ? (
			<Col>Loading...</Col>
		) : (
			<Col>
				{showLabel && (
					<label className="form-label" htmlFor="formsupplierSetID">
						{showLabel}
					</label>
				)}
				<select
					name="supplierSetID"
					id="formsupplierSetID"
					className="form-control form-select form-control"
					value={selectedVendorSetID}
						onChange={(e) => selectSetId(e.target.value)}>
						{/* Show default "Select Supplier Set ID" option unless explicitly hidden by props.*/}
						{(typeof props.showSelectOption === 'undefined' || props.showSelectOption) && (
							<option value="">Select Supplier Set ID</option>
						)}
						{vendorSetIDList &&
							vendorSetIDList.map((type, index) => (
								<option key={index} value={type}>
									{type}
								</option>
							))}
				</select>
			</Col>
		)
	);
};
